/* eslint-disable camelcase */
import * as React from "react"
import * as yup from "yup"
import moment from "moment"
import numeral from "numeral"
import { Appearance } from "react-native"
import { ShrimpPrice } from "../../../database"
import { FormProps } from "../form"
import { Formik } from "formik"
import { ModelField } from "../../field/model-field/model-field"
import { Divider, View } from "native-base"
import { nativeBaseTheme } from "../../../theme"
import { observer } from "mobx-react-lite"
import { translate } from "../../../i18n"
import { Text } from "../../text/text"
import { useStores } from "../../../models"
import { BatchStoreModel } from "../../../models/app-store/farm-store/batch-store/batch-store"

export interface SimulationHarvestPriceFormProps extends FormProps {
  /**
   * An optional style override useful for padding & margin.
   */
  initialValues?: {
    farm_id?: number
    shrimp_price_id?: number
  }
}

/**
 * Describe your component here
 */
export const SimulationHarvestPriceForm = observer(function SimulationHarvestPriceForm(props: SimulationHarvestPriceFormProps) {
  const {
    initialValues = {}, onSubmit, colorScheme = Appearance.getColorScheme(), innerRef,
    ...rest
  } = props

  const { appStore: { farmStore: { activeBatchStore } } } = useStores()
  const { batch } = activeBatchStore || BatchStoreModel.create()

  // const input = {
  //   //
  // }

  // const nextInput = {
  //   //
  // }

  const validationSchema = yup.object({
    farm_id: yup.number().nullable().required().label(translate("farmShrimpPriceForm.farmId")),
    shrimp_price_id: yup.number().nullable().required().label(translate("farmShrimpPriceForm.shrimpPriceId")),
  })

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      innerRef={innerRef}
      {...rest}
    >
      {({ initialValues, values, setFieldValue, setFieldTouched }) => (
        <>
          <Text tx="farmShrimpPriceForm.title" preset="title3" marginX="16px" marginY="8px" colorScheme={colorScheme} />
          <Text
            tx="farmShrimpPriceForm.subtitle"
            preset="body3"
            marginX="16px"
            marginY="8px"
            colorScheme={colorScheme}
            color={nativeBaseTheme.colors.gray[colorScheme === "light" ? "700" : "300"]}
          />
          <ModelField
            key={`${values.farm_id}-shrimp_price_id`}
            name="shrimp_price_id"
            txPrefix="farmShrimpPriceForm"
            colorScheme={colorScheme}
            formControlProps={{
              isRequired: true,
              helperText: (batch || {}).start_batch ? translate('farmShrimpPriceForm.helperText', { date: moment(batch.start_batch).format('DD MMM YYYY') }) : undefined,
              helperTextProps: { color: nativeBaseTheme.colors.gray[colorScheme === "light" ? "700" : "300"] }
            }}
            modelPickerProps={{
              Model: ShrimpPrice,
              dataLabel: "size_100",
              fetchData: (model, search) => (
                model.fetch({
                  search,
                  with: 'region,currency',
                  sort: "date,desc",
                  date__gte: (batch || {}).start_batch ? (batch || {}).start_batch : undefined,
                  per_page: (batch || {}).start_batch ? 1000 : 100,
                })
              ),
              pickerActionsheetProps: {
                renderItem({ item }) {
                  const currencySymbol = item.currency && item.currency.symbol || item.currency_id
                  const regionName = item.region && item.region.full_name || '-'

                  return <View paddingY="12px" paddingX="16px" backgroundColor={item.id === values.shrimp_price_id ? nativeBaseTheme.colors.gray[colorScheme === 'light' ? "100" : "900"] : undefined}>
                    <View flexDirection="row" justifyContent="space-between">
                      <Text text={moment(item.date).format('DD MMMM YYYY')} preset="title4" colorScheme={colorScheme} />
                      <Text text={`${currencySymbol || ''} ${numeral(item.size_100).format('0,0.[00]')}`} preset="title4" colorScheme={colorScheme} />
                    </View>
                    <Text text={regionName} preset="body2" colorScheme={colorScheme} color={nativeBaseTheme.colors.gray[colorScheme === 'light' ? "700" : "300"]} />
                    <Divider backgroundColor={nativeBaseTheme.colors.gray[colorScheme === 'light' ? "100" : "900"]} />
                  </View>
                },
              },
              renderSelectedItemText: (item) => {
                const currencySymbol = item.currency && item.currency.symbol || item.currency_id

                return item && `${currencySymbol || ''} ${numeral(item.size_100).format("0,0.[00]")}, ${moment(item.date).format("DD MMM YYYY")}, ${item.region.full_name}`
              },
              clearable: true,
              isDisabled: !values.farm_id || !!initialValues.shrimp_price_id,
            }}
          />
        </>
      )}
    </Formik>
  )
})

SimulationHarvestPriceForm.displayName = 'SimulationHarvestPriceForm'
